import { Layer, Box, Text, Anchor } from 'grommet';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useSetRecoilState } from 'recoil';
import { isSettingsOpen } from '@/recoil/atom/globalState';

type Props = {
	setShow: ({
		show,
		name,
		type,
	}: {
		show: boolean;
		name: string;
		type: string;
	}) => void;
	name: string;
	type: string;
};

export const DeviceError = ({ setShow, name, type }: Props) => {
	const { t } = useTranslation('default');
	const setSttingsOpen = useSetRecoilState(isSettingsOpen);
	const hideModal = () => setShow({ show: false, name: '', type: '' });

	const openSettings = () => {
		hideModal();
		setSttingsOpen(true);
	};
	return (
		<Layer onEsc={hideModal} onClickOutside={hideModal}>
			<Box pad="large" align="center">
				<Text weight="bold">{t('modals.device_error')}</Text>
				<Text margin={{ top: '10px', bottom: '10px' }}>
					{t('modals.device_error_description')}
				</Text>
				<Text weight="bold" margin={{ top: '10px', bottom: '10px' }}>
					{`${t('modals.device')} ${name} ${type}`}
				</Text>
				<Text margin={{ top: '10px', bottom: '10px' }} textAlign="center">
					{t('modals.device_error_description_2')}
				</Text>
				<Anchor onClick={openSettings} label={t('modals.open_settings')} />
			</Box>
		</Layer>
	);
};
